/** Блоки секции «Рост автора» (каждая строка — отдельная линия с <br>). */
export const authorGrowthBlocks = [
  {
    title: ['Хочешь найти своих', 'читателей'],
    description: ['Неважно, знакомый это мир', 'или созданный тобой.'],
  },
  {
    title: ['Хочешь писать сильнее'],
    description: ['Развивать сюжет, героев, стиль', 'и авторский голос.'],
  },
  {
    title: ['Хочешь стать заметнее'],
    description: ['Попадать в подборки, проекты', 'и обсуждения.'],
  },
  {
    title: ['Ищешь поддержку'],
    description: ['Быть частью сообщества,', 'где ценят разные истории.'],
  },
  {
    title: ['Готов к новым форматам'],
    description: ['Медиа, сборники, события', 'и совместные проекты.'],
  },
  {
    title: ['Пишешь по-разному'],
    description: ['Можно совмещать фанфики', 'и собственные миры.'],
  },
] as const;
